"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _designSystem = require("@slyk/design-system");

var _media = require("react-components/media");

var _styles = require("./styles");

var _styledTools = require("styled-tools");

var _styles2 = require("react-components/styles");

var _breakpoint = require("@slyk/breakpoint");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var emailIcon16 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><g fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\"><path d=\"M2.039 3.129c.363-.473.866-.723 1.374-.723h9.175c.507 0 1.011.25 1.373.723l.554.722c.308.402.485.929.485 1.484v5.33a2.45 2.45 0 01-.485 1.484l-.553.722c-.363.473-.866.723-1.374.723H3.412c-.507 0-1.011-.25-1.374-.723l-.553-.722A2.452 2.452 0 011 10.665v-5.33c0-.555.177-1.082.485-1.484l.554-.722\"/><path d=\"M3.312 4.719l1.173 1.579c.526.697 1.241 1.135 2.01 1.233H9.47c.77-.098 1.485-.535 2.01-1.233l1.207-1.579\"/></g></svg>";
var emailIcon24 = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M3.3 5.675c.573-.745 1.377-1.152 2.2-1.152h13.457c.824 0 1.629.407 2.2 1.152l.812 1.059c.485.633.76 1.457.76 2.319v7.816c0 .862-.275 1.686-.76 2.319l-.812 1.059c-.571.745-1.375 1.151-2.2 1.151H5.5c-.824 0-1.629-.406-2.2-1.151l-.812-1.059c-.485-.633-.76-1.457-.76-2.319V9.053c0-.862.275-1.686.76-2.319l.813-1.059z\"/><path stroke=\"currentColor\" stroke-miterlimit=\"10\" d=\"M5.354 8.148l1.72 2.317c.771 1.023 1.82 1.665 2.949 1.808h4.362c1.13-.143 2.178-.784 2.949-1.808l1.77-2.317\"/></svg>";

/**
 * Responsive style.
 */
var responsiveStyle = (0, _styledComponents.css)(["padding:9px ", ";", ""], (0, _styles2.units)(1.5), _styles2.media.min('ms')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 15px ", ";\n  "])), (0, _styles2.units)(2)));
/**
 * `StyledFlatButton` styled component.
 */

var StyledFlatButton = (0, _styledComponents["default"])(_designSystem.FlatButton).withConfig({
  displayName: "email-button__StyledFlatButton",
  componentId: "sc-128rwbx-0"
})(["", ""], (0, _styledTools.ifProp)('responsive', (0, _styledComponents.css)(["", ""], responsiveStyle), (0, _styledComponents.css)(["padding:15px ", ";"], (0, _styles2.units)(2))));
/**
 * `EmailButton` component.
 */

function EmailButton(props) {
  var children = props.children,
      disabled = props.disabled,
      onClick = props.onClick,
      responsive = props.responsive,
      to = props.to;
  var isDesktop = (0, _breakpoint.useBreakpoint)('ms', 'min');
  var isResponsive = !!responsive;
  var iconButton = isDesktop ? emailIcon24 : emailIcon16;
  var iconSize = isDesktop ? (0, _styles2.units)(3) : (0, _styles2.units)(2);
  return /*#__PURE__*/_react["default"].createElement(StyledFlatButton, {
    colorTheme: 'secondary',
    disabled: disabled,
    fullWidth: true,
    onClick: onClick,
    responsive: responsive,
    size: 'large',
    to: to
  }, /*#__PURE__*/_react["default"].createElement(_styles.SocialButtonContent, null, /*#__PURE__*/_react["default"].createElement(_media.Icon, {
    "aria-hidden": true,
    color: 'inherit',
    icon: isResponsive ? iconButton : emailIcon24,
    size: isResponsive ? iconSize : (0, _styles2.units)(3)
  }), children));
}
/**
 * Export `EmailButton` component.
 */


var _default = EmailButton;
exports["default"] = _default;